import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Phone } from "lucide-react";
import { Logo, Wordmark } from "./Logo";
import Footer from "./Footer";

export default function BlogLayout({ children }) {
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <div className="bg-white min-h-screen">
      <header
        className={`fixed top-0 inset-x-0 z-50 transition-all duration-300 ${
          scrolled ? "bg-white/90 backdrop-blur-md border-b border-slate-200 shadow-sm" : "bg-white border-b border-slate-100"
        }`}
      >
        <nav className="max-w-5xl mx-auto px-5 lg:px-8 h-[72px] flex items-center justify-between">
          <Link to="/" data-testid="blog-logo" className="flex items-center gap-2.5">
            <Logo className="w-11 h-11 shrink-0" />
            <Wordmark />
          </Link>
          <div className="flex items-center gap-1 sm:gap-2">
            <Link to="/" className="px-3 sm:px-4 py-2 rounded-full text-sm font-semibold text-slate-600 hover:text-sky-700 hover:bg-sky-50">
              Főoldal
            </Link>
            <Link to="/blog" className="px-3 sm:px-4 py-2 rounded-full text-sm font-semibold text-sky-700 bg-sky-50">
              Blog
            </Link>
            <Link
              to="/#arajanlat"
              data-testid="blog-quote-cta"
              className="inline-flex items-center gap-2 bg-sky-600 hover:bg-sky-500 text-white px-4 sm:px-5 py-2.5 rounded-full text-sm font-bold shadow-lg shadow-sky-600/20 transition-colors"
            >
              <Phone className="w-4 h-4" /> <span className="hidden sm:inline">Árajánlat</span>
            </Link>
          </div>
        </nav>
      </header>
      <main className="pt-[72px]">{children}</main>
      <Footer />
    </div>
  );
}
